import { useContext } from 'react';
import NothingHere from '../custom-components/NothingHere';
import { GlobalContext, GlobalContextProps } from '../global-context';
import General from '../utils/GeneralUtils';

export function NotFound(props: any) {

  const globalContext = useContext(GlobalContext);
  General.setTitle(document, 'Not Found', globalContext);

  return <GlobalContext.Consumer>
    {
      (globalContextProps: GlobalContextProps) => <>
        <div className="content content-800">
          <h1>Not Found :(</h1>
          <NothingHere text="This page does not exists. Please double check the URL or navigate to the Homepage." />
        </div>
      </>
    }
  </GlobalContext.Consumer>
}
